// @ts-nocheck
import { GetStoreListsApiParameter } from "@store/Services/StoreListService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetStoreListsApiParameter>;

export const DispatchUpdateLoadParameter: HandlerType = props => {
    props.dispatch({
        type: "Pages/StoreLists/UpdateLoadParameter",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateLoadParameter];

const storeListsUpdateLoadParameter = createHandlerChainRunner(chain, "StoreListUpdateLoadParameter");
export default storeListsUpdateLoadParameter;
